var _linearGradient, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBithumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120.98 158.84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 115.47,
    x2: 70.16,
    y1: 113.94,
    y2: 44.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f47320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f16d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e95c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#dc4125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d53127"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.59 37.83h22.61l-17.58 43s-9.19-.15-12-8.18a12.76 12.76 0 0 1 -.19-7.37z",
    fill: "#d53127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m95.28 38.75-28.75-.5 6.47-21.34a13.09 13.09 0 0 0 -12.48-16.91h-26.24l-30 107.75s-10.75 46.08 30 50.25c0 0 64.42 13.17 85.09-64.67 0 0 10.91-47.08-24.09-54.58zm-19.65 53.44s-1.15 19.88-16.15 23.37a9.72 9.72 0 0 1 -6.61-.68c-2.35-1.2-4.78-3.69-4.72-8.91a16.82 16.82 0 0 1 .72-4.45l5.54-20.69h15.12s6.85 2.23 6.1 11.36z",
    fill: "#f47320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120.75 71.63c-2.75-31.63-25.47-32.88-25.47-32.88l-28.75-.5-12.35 42.83h15.08c2.77.15 7.82 4.72 6.18 12.81",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBithumb);
export default __webpack_public_path__ + "static/media/bithumb.ae42052b0a5078b2e9cc7a98e3db1788.svg";
export { ForwardRef as ReactComponent };